var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title-component',{attrs:{"title":"Menus","subtitle":"Lista de Menus"}}),(_vm.display.table == true)?_c('table-screen',{on:{"screen":_vm.Screen}}):_vm._e(),(_vm.display.add == true)?_c('add-screen',{on:{"screen":_vm.Screen}}):_vm._e(),(_vm.display.edit == true)?_c('edit-screen',{on:{"screen":_vm.Screen}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }